var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.hasData)?[_vm._v("\n    "+_vm._s(_vm.calculatedTime.duration)+" "),_c('span',[_vm._v(_vm._s(_vm.calculatedTime.units))])]:[_vm._v(" -- ")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }